// Class: motion.actuators.PropertyDetails

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;

// Constructor

var PropertyDetails = function(target,propertyName,start,change,isField) {
	if(isField == null) {
		isField = true;
	}
	this.target = target;
	this.propertyName = propertyName;
	this.start = start;
	this.change = change;
	this.isField = isField;
}

// Meta

PropertyDetails.__name__ = ["motion","actuators","PropertyDetails"];
PropertyDetails.__isInterface__ = false;
PropertyDetails.prototype = {
	
};
PropertyDetails.prototype.__class__ = PropertyDetails.prototype.constructor = $hxClasses["motion.actuators.PropertyDetails"] = PropertyDetails;

// Init



// Statics




// Export

exports.default = PropertyDetails;